import { Pipe, PipeTransform } from '@angular/core';
import { Message } from 'app/core/models/message';

@Pipe({ name: 'sortMessageWithTime', standalone: true })
export class SortMessageWithTimePipe implements PipeTransform {
  
  transform(messages: Message[] |null, order: string = 'asc'): Message[] {
    if (!messages) {
      return [];
    }
    return messages.sort((a, b) => {
      const dateA = this.parseTime(a.createdAt || '');
      const dateB = this.parseTime(b.createdAt || '');

      if (order === 'asc') {
        return dateA.getTime() - dateB.getTime();
      } else {
        return dateB.getTime() - dateA.getTime();
      }
    });
  }

  private parseTime(timeStr: string): Date {
    const timePart = timeStr.split('_')[0];
    return new Date(timePart);
  }
}
